import React from 'react';
import { Link } from 'react-router-dom';
import DropdownUser from '../../components/DropdownUser';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { MdMenu, MdOutlineSupportAgent, MdOpenInNew } from 'react-icons/md';

const MenuIcon = MdMenu as React.ElementType;
const ContactIcon = MdOutlineSupportAgent as React.ElementType;
const OpenInNewIcon = MdOpenInNew as React.ElementType;

const Header = (props: {
  sidebarOpen: string | boolean | undefined;
  setSidebarOpen: (arg0: boolean) => void;
}) => {
  const { t } = useTranslation();
  const pendingCount = useSelector((state: RootState) => state.contact.pendingCount);

  return (
    <header className="sticky top-0 z-50 flex w-full h-16 bg-white drop-shadow-sm border-b border-gray-100 shrink-0">
      <div className="flex flex-grow items-center justify-between px-3 sm:px-4 md:px-6 2xl:px-11 h-full">
        {/* Left Side: Hamburger Menu & Mobile Logo */}
        <div className="flex items-center gap-2 sm:gap-3 shrink-0">
          {/* Hamburger Toggle Button */}
          <button
            aria-controls="sidebar"
            aria-label="Toggle navigation menu"
            onClick={(e) => {
              e.stopPropagation();
              props.setSidebarOpen(!props.sidebarOpen);
            }}
            className="flex items-center justify-center p-1.5 sm:p-2 rounded-lg border border-gray-200 bg-white text-gray-700 hover:text-[#041B44] hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200 lg:hidden transition-colors shadow-xs"
          >
            <MenuIcon className="w-5 h-5 text-gray-700" />
          </button>

          <Link className="flex items-center shrink-0 lg:hidden hover:opacity-90 transition-opacity" to="/admin/dashboard" title="Centre SEVA Dashboard">
            <img src="/images/bluelogo-new.png" alt="Centre SEVA Logo" className="h-8 sm:h-9 w-auto object-contain" />
          </Link>
        </div>

        {/* Right Side: Quick Action & Controls */}
        <div className="flex items-center ml-auto gap-1 sm:gap-3 shrink-0">
          {/* Contact Inquiries Notification Bell / Icon */}
          <Link
            to="/admin/contacts"
            className="relative flex items-center justify-center p-1.5 sm:p-2 rounded-lg text-gray-600 hover:text-[#037897] hover:bg-gray-100 transition-colors"
            title={pendingCount > 0 ? `${pendingCount} pending contact inquiries` : t("adminNav.contacts", "Contact Requests")}
          >
            <ContactIcon className="w-5 h-5 shrink-0 text-gray-600 hover:text-[#037897]" />
            {pendingCount > 0 && (
              <span className="absolute -top-1 -right-1 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-[#E53E3E] px-1 text-[10px] font-bold text-white shadow-xs animate-pulse">
                {pendingCount > 99 ? '99+' : pendingCount}
              </span>
            )}
          </Link>

          {/* Switch to User View / Public Site */}
          <Link
            to="/"
            className="flex items-center gap-1.5 px-2 py-1.5 sm:px-3 text-xs sm:text-sm font-semibold text-[#037897] bg-[#E0F2F7] hover:bg-[#bce6f1] rounded-lg transition-colors border border-[#037897]/20 whitespace-nowrap shadow-xs"
            title={t("adminNav.viewSite")}
          >
            <OpenInNewIcon className="w-4 h-4 shrink-0 text-[#037897]" />
            <span className="hidden sm:inline">{t("adminNav.viewSite")}</span>
          </Link>

          {/* Language Switcher - visible on medium & large screens (on mobile it lives inside the sidebar) */}
          <div className="hidden md:block border-l border-r border-gray-200 px-2 sm:px-3 py-0.5">
            <LanguageSwitcher theme="light" />
          </div>

          {/* User Dropdown */}
          <DropdownUser />
        </div>
      </div>
    </header>
  );
};

export default Header;
